/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_CAPACITY_URL, COMMON_HEADER_CONFIG} from "../config";

class CapacityTimeSlotService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListCapacities = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CAPACITY_URL}/capacities`,
        params: {
          per_page: 100,
          page: 1,
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createCapacity = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.position = Number(dataCreate.position);
      dataCreate.capacity = Number(dataCreate.capacity);

      const config = {
        method: "post",
        url: `${API_CAPACITY_URL}/capacity`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            (response.data && response.data.code === 1) ||
            response.data.code === "success"
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCapacity = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = data;
      dataUpdate.position = Number(dataUpdate.position);
      dataUpdate.capacity = Number(dataUpdate.capacity);

      const config = {
        method: "patch",
        url: `${API_CAPACITY_URL}/capacity/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataUpdate
      };

      axios(config)
        .then((response) => {
          if (
            (response.data && response.data.code === 1) ||
            response.data.code === "success"
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCapacity = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CAPACITY_URL}/capacity/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            (response.data && response.data.code === 1) ||
            response.data.code === "success"
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteCapacity = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_CAPACITY_URL}/capacity/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const capacityTimeSlotService = new CapacityTimeSlotService();

export default capacityTimeSlotService;
